import { lazy } from 'react'
import { Route, Routes } from 'react-router'
import { namedExportToDefaultExport } from 'utils'

const AppointmentGuides = lazy(() =>
  import(
    /* webpackChunkName: "AppointmentGuides" */
    'components/AppointmentGuides'
  ).then(namedExportToDefaultExport('AppointmentGuides'))
)

const Router = () => (
  <Routes>
    <Route element={<AppointmentGuides />} path="*" />
  </Routes>
)

export { Router as AppointmentGuides }
